import authApi from '../api/auth';
import { LOGOUT_ICON, MESSAGE_SVG, NOTIFICATIONS_SVG } from '../assets/icons';
import { AVATAR } from '../assets/images';
import { useAppDispatch } from '../hooks/useRedux';
import { login } from '../reducers/authSlice';

const Header = () => {
  const dispatch = useAppDispatch();
  const logout = async () => {
    await authApi.logout().catch((err) => console.log(err));
    dispatch(login({ admin: null }));
  };
  return (
    <div className="w-full h-14 flex items-center justify-end bg-white p-4 drop-shadow-md">
      <div className="flex gap-4">
        {/* <div className="relative w-8 h-8 rounded-full bg-neutralBlue2 border border-neutralGray3 flex items-center justify-center cursor-pointer">
          <img src={MESSAGE_SVG} alt="message_svg" className="w-4" />
          <span className="absolute -right-1 -top-2 w-2 h-2 flex items-center justify-center bg-secondary text-white text-xs p-2 rounded-full">3</span>
        </div>

        <div className="relative w-8 h-8 rounded-full bg-neutralBlue2 border border-neutralGray3 flex items-center justify-center cursor-pointer">
          <img src={NOTIFICATIONS_SVG} alt="message_svg" className="w-4" />
          <span className="absolute -right-1 -top-2 w-2 h-2 flex items-center justify-center bg-secondary text-white text-xs p-2 rounded-full">3</span>
        </div> */}

        <div className="relative w-5 rounded-full flex items-center justify-center cursor-pointer">
          <img src={LOGOUT_ICON} alt="Logout icon" className="w-full h-full object-cover" onClick={() => logout()} />
        </div>
      </div>
    </div>
  );
};

export default Header;
